import * as React from "react"

const TrxSvg = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
        <path fill="#C4342B" d="M0 0h56v56H0z" />
        <path
            fillRule="evenodd"
            d="M15.4 14.484a1 1 0 0 1 .98-.301l21.1 5.166c.127.031.246.087.352.163l4.293 3.13a1 1 0 0 1 .236 1.372l-14.77 21.61a1 1 0 0 1-1.769-.23L15.2 15.49a1 1 0 0 1 .2-1.005zm3.482 5.397 7.374 20.76 1.213-10.759-8.587-10.001zm10.56 10.348L28.21 41.175l10.43-15.263-9.199 4.317zm10.139-6.967-6.723 3.155 4.507-4.77 2.216 1.615zm-4.246-2.379L18.93 16.866l9.618 11.202 6.788-7.185z"
            fill="#fff"
        />
    </svg>
)

export default TrxSvg
